<div>
    <form nz-form #categoryPage="ngForm">
        <div nz-row class="my-box" nzGutter="15">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Category</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Category Name is Required">
                        <input nz-input autocomplete="off" name="name" type="text" placeHolder="Enter Category"
                            [(ngModel)]="data.NAME" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Active</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(categoryPage)"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button nz-dropdown [nzDropdownMenu]="menu" *ngIf="!data.ID"
        (click)="save(false)"><span>Save & Close</span></button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu>

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="reset(categoryPage)"><span>Reset</span></button> -->
</div>